import { get } from "./utils";

export const addressbook = {
  list: (parameters, token) => {
    return get("/api/basis/addressbooks/", parameters, token);
  },

};

